import React, {useState} from "react";
import {RiEmotionHappyLine, RiSendPlane2Fill} from "react-icons/ri";
import styled from "styled-components";
import EmojiPicker from "emoji-picker-react";
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {sendMessage} from "../../Redux/actions/messageAction";

const ChatFooter = ({sendMessage, selectedContact, selectedGroup, currentUser, socket}) => {
    const [msg, setMsg] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    const toggleEmojiPicker = () => {
        setShowEmojiPicker(!showEmojiPicker);
    };

    const handleEmojiClick = (emojiData, event) => {
        console.log(emojiData)
        console.log(event)
        let message = msg;
        message += emojiData.emoji;
        setMsg(message);
    };

    const sendChat = (event) => {
        event.preventDefault();
        if (msg.trim().length > 0) {
            const isGroup = !selectedGroup ? false : true;
            const destination = isGroup ? selectedGroup : selectedContact;
            sendMessage(msg, destination.id, isGroup);

            setMsg("");
            setShowEmojiPicker(false);
        }
    };

    return (
        <Container>
            <div className="button-container">
                <div className="emoji">
                    <RiEmotionHappyLine onClick={() => toggleEmojiPicker()}/>
                    {showEmojiPicker &&
                        <EmojiPicker searchDisabled={true} skinTonesDisabled={true} lazyLoadEmojis={true}
                                     showPreview={false}
                                     previewConfig={{showPreview: false}} onEmojiClick={handleEmojiClick}/>}
                </div>
            </div>
            <form className="input-container" onSubmit={(event) => sendChat(event)}>
                <textarea
                    type="text"
                    placeholder="Enter Message..."
                    onChange={(e) => setMsg(e.target.value)}
                    value={msg}
                />
                <button type="submit">
                    <RiSendPlane2Fill/>
                </button>
            </form>
        </Container>
    );
}

ChatFooter.propTypes = {
    sendMessage: PropTypes.func.isRequired,
    selectedContact: PropTypes.object,
    selectedGroup: PropTypes.object,
    currentUser: PropTypes.object,
    socket: PropTypes.object,
};

const mapStateToProps = (state) => ({
    selectedContact: state.contact.selectedContact,
    selectedGroup: state.contact.selectedGroup,
    currentUser: state.auth.user,
    socket: state.auth.socket,
});

export default connect(mapStateToProps, {sendMessage})(ChatFooter);

const Container = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 5% 95%;
  padding: 0 1.5rem;
  border-top: #F0EFF5 1px solid;

  @media screen and (max-width: 600px) {
    padding: 0 0.5rem;
  }

  .button-container {
    display: flex;
    align-items: center;
    color: white;
    gap: 1rem;

    .emoji {
      position: relative;

      svg {
        font-size: 1.75rem;
        color: #7269EF;
        cursor: pointer;
      }

      .EmojiPickerReact {
        position: absolute;
        top: -410px;
        z-index: 2;
        height: 380px !important;
        width: 300px !important;

        //background-color: #080420;
        //box-shadow: 0 5px 10px #9a86f3;
        //border-color: #9a86f3;

        @media screen and (max-width: 400px) {
          width: 220px !important;
        }

        .epr-body {
          &::-webkit-scrollbar {
            width: 0.5rem;

            &-thumb {
              background-color: #D1D6DB;
              width: 0.1rem;
              border-radius: 1rem;
            }
          }
        }
      }
    }
  }

  .input-container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;

    @media screen and (max-width: 600px) {
      gap: 0.5rem;
    }

    textarea {
      width: 90%;
      height: 20px;
      max-height: 20px;
      color: #495057;
      border: none;
      font-size: 1rem;
      background-color: #E6EBF5;
      border-radius: 0.5rem;
      padding: 0.9rem 0.9rem;
      resize: none;

      &::-webkit-scrollbar {
        width: 0.5rem;

        &-thumb {
          background-color: #D1D6DB;
          width: 0.1rem;
          border-radius: 1rem;
        }
      }

      @media screen and (max-width: 1200px) {
        margin-left: 10px;
      }
      @media screen and (max-width: 600px) {
        margin-left: 20px;
      }

      &::selection {
        background-color: #9a86f3;
      }

      &:focus {
        outline: none;
      }
    }

    button {
      padding: 0.9rem 0.9rem;
      border-radius: 0.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #7269EF;
      border: none;
      cursor: pointer;

      svg {
        font-size: 1rem;
        color: white;
      }
    }
  }
`;
